<template>
    <v-layout>
        <v-flex>
            <v-data-table
                :headers="headers"
                :items="usuarios"
                sort-by="calories"
                :search="search"
                class="elevation-1"
                >
                <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-toolbar-title>Usuarios</v-toolbar-title>
                        <v-divider
                            class="mx-4"
                            inset
                            vertical
                        ></v-divider>
                        <v-spacer></v-spacer>
                        <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                        <v-spacer></v-spacer> 
                        <v-dialog v-model="AddUserdialog" max-width="500px" persistent>
                            <template v-slot:activator="{ on }">
                                <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
                            </template>
                                <v-card>
                                    <v-card-title>
                                        <span style="color: rgb(16 114 191);font-weight: 600;" class="headline">Add User</span>
                                    </v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field 
                                                    :rules="[rules2.required, rules2.email]"
                                                    label="E-mail"
                                                    v-model="login"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="nombre" label="*Nombre"
                                                    :rules="[rules2.required, rules2.name]"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="apellido" label="*Apellido"
                                                    :rules="[rules2.required, rules2.name]"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-select v-model="idconsignotario" :items="consignatario" label="*Consignatario"
                                                    :rules="[rules2.required, rules2.name]"
                                                    ></v-select>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field 
                                                    :append-icon="show4 ? 'visibility' : 'visibility_off'"
                                                    :rules="[rules.required, rules.min]"
                                                    :type="show4 ? 'text' : 'password'"
                                                    name="input-10-2"
                                                    label="*Password"
                                                    hint="At least 8 characters"
                                                    value="wqfasds"
                                                    class="input-group--focused"
                                                    @click:append="show4 = !show4"
                                                    v-model="password"></v-text-field>
                                                    <v-btn color="primary" @click="generarcontraseña()">Generar Contraseña</v-btn>
                                                </v-col>                                
                                                <v-col cols="12" sm="12" md="12" v-show="valida">
                                                    <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v"></div>
                                                </v-col>                                                        
                                            </v-row>
                                        </v-container>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="AddUserdialog = false">Cancelar</v-btn>
                                        <v-btn color="blue darken-1" text @click="GuardarUsuario">Guardar</v-btn>
                                    </v-card-actions>
                                </v-card>
                        </v-dialog>
                        <v-dialog  v-model="adModal" max-width="290px">
                            <v-card>
                                <v-card-title class="headline" v-if="adAccion==1">¿Activar Item?</v-card-title>
                                <v-card-title class="headline" v-if="adAccion==2">¿Desactivar Item?</v-card-title>
                                <v-card-text>
                                    Estás a punto de
                                    <span v-if="adAccion==1">Activar</span>
                                    <span v-if="adAccion==2">Desactivar</span>
                                    el item {{ adNombre }}
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="green darken-1" text="text" @click="">
                                        Cancelar
                                    </v-btn>
                                    <v-btn v-if="adAccion==1" color="orange darken1" text="text" @click="activar">
                                        Aceptar
                                    </v-btn>
                                    <v-btn v-if="adAccion==2" color="orange darken1" text="text" @click="desactivar">
                                        Desactivar
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.activo`]="{ item }">  
                    <div v-if="item.activo" style="text-align: center;">
                        <span class="blue--text">Activo</span>                            
                    </div>
                    <div v-else style="text-align: center;">
                        <span class="red--text">Inactivo</span>                
                    </div>                  
                </template>
                <template v-slot:[`item.opciones`]="{ item }" >
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">                   
                            <v-icon
                            v-bind="attrs"
                            v-on="on"
                                small
                                class="mr-2"
                                @click="editar(item)" 
                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                color="#3d5170"
                                >
                                edit
                            </v-icon>
                        </template>
                        <span>Edit</span>
                    </v-tooltip>
                </template>  
            </v-data-table>
        </v-flex>
    </v-layout>
</template>
<script>
import axios from 'axios'      
export default {
    data() {
        return{
            headers: [
                { text: 'Opciones', value: 'opciones', sortable: false },                        
                { text: 'Login', value: 'login' },
                { text: 'Nombre', value: 'nombre' },
                { text: 'Apellido', value: 'apellido' },   
                { text: 'Consignatario', value: 'cnn', sortable: false  },                               
                { text: 'Estado', value: 'activo', sortable: false  },                                
            ],
            usuarios:[],
            search:'',
            AddUserdialog:false,
            login:'',
            nombre:'',
            apellido:'',
            idconsignotario:0,
            password:'',
            consignatario:[],
            valida:0,
            validaMensaje:[],
            adModal:false,
            adAccion:0,
            adNombre:'',
            editedIndex:-1,
            idcliente:0,
            show4: false,
            show2:false,
            idusuario:0,
            rules: {
                required: value => !!value || 'Obligarorio.',
                min: v => v.length >= 8 || 'Min 8 caracteres',
                name: [val => (val || '').length > 0 || 'Este campo es obligatorio'],
            },
            rules2: {
                required: value => !!value || 'Obligarorio.',
                counter: value => value.length <= 50 || 'Max 50 caracteres',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Email inválido.'
                },
            }
        }
    },
    created () {        
        this.listar();
        this.CargarCnee();
        //this.generarcontraseña();
    },
    methods:{
        listar(){//mandamos llamar el controlador Categorias y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            
            me.idcliente = this.$store.state.usuario.idcliente;

            axios.get('api/Usuarios/ListarUsuarioCliente/' + this.$store.state.usuario.idcliente ,configuracion).then(function(response){
              me.usuarios=response.data;
            }).catch(function(error){
              console.log(error);
            });
        },
        CargarCnee(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let me=this;
            var consignatarioarray = [];
            me.consignatario= [];

            axios.get('api/Enlace_Cliente_Proveedor/SelectCnee/'+ this.$store.state.usuario.idcliente + '/' + this.$store.state.usuario.idusuario ,configuracion).then(function(response){            
                consignatarioarray=response.data;
                consignatarioarray.map(function(x){
                    me.consignatario.push({text:x.nombre,value:x.idprovedor});
                });
                me.DialogCnee =  false;
            }).catch(function(error){
                console.log(error);
            });
        },
        editar(item){
            console.log(item)
            this.editedIndex = this.usuarios.indexOf(item)
            this.login = item.login;
            this.nombre = item.nombre;
            this.apellido = item.apellido;
            this.password = item.password;
            this.idcliente = item.idcliente;
            this.idconsignotario = item.id_consignatario;
            this.idusuario = item.idusuario;
            this.AddUserdialog = true;
            this.actpassword = false;

        },
        GuardarUsuario(){
            /*if(this.validar()){
                return;
            }*/
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let me=this;

                var idrol = 1012;
                var passwordemailogl = "-";
                var email_p = "-";
                var ext = "-";
                var Celular_p = "-";
                var Telefono_p = "-";
                var email_ogl = "-";
                if(me.actpassword == false){
                    me.password = '-';
                }
            if (this.editedIndex > -1) {//codigo para editar
                axios.put('api/Usuarios/Actualizar',{
                    'idusuario':me.idusuario,
                    'idrol_usuario':idrol,
                    'nombre':me.nombre,
                    'login':me.login,
                    'apellido':me.apellido,
                    'Telefono_p':Telefono_p,
                    'Celular_p':Celular_p,
                    'ext':ext,
                    'email_p':email_p,
                    'email_ogl':email_ogl,
                    'password':me.password,
                    'passwordemail':passwordemailogl,
                    'id_cliente':me.idcliente,
                    'id_consignatario':me.idconsignotario,
                    'act_password':me.actpassword,
                },configuracion).then(function(response){
                    
                    //me.listar();
                    me.limpiar();
                    window.alert('Usuario Actualizado Correctamente');
                    me.AddUserdialog = false;  
                }).catch(function(error){
                    console.log(error);
                });  
            } else {//codigo para guardar
                    axios.post('api/Usuarios/Crear',{
                        'idrol_usuario':idrol,
                        'nombre':me.nombre,
                        'login':me.login,
                        'apellido':me.apellido,
                        'Telefono_p':Telefono_p,
                        'Celular_p':Celular_p,
                        'ext':ext,
                        'email_p':email_p,
                        'email_ogl':email_ogl,
                        'password':me.password,
                        'passwordemail':passwordemailogl,
                        'id_cliente':me.idcliente,
                        'id_consignatario':me.idconsignotario,
                    },configuracion).then(function(response){
                        me.limpiar()
                        window.alert('Usuario Guardado Correctamente');
                        me.AddUserdialog = false;  
                    }).catch(function(error){
                        console.log(error);
                    });                          
                }     
        },
        validar(){
            console.log('entra')
            this.valida=0;

            this.validaMensaje=[];

            if(this.nombre.length < 3 || this.nombre.length >100){
                this.validaMensaje.push("El nombre debe tener mas de 3 caracteres y menos de 100 caracteres.");
            }
            if(!this.login) {
                this.validaMensaje.push("Ingresa el login del usuario.");
            }
            if(!this.password.length < 8 || this.password.length == ''){
                this.validaMensaje.push("Ingresa un password.");
            }

            return this.valida;
        },
        limpiar(){
            this.login = '';
            this.nombre = '';
            this.apellido = '';
            this.password = '';
            this.idcliente = '';
            this.idconsignotario = '';
        },
        generarcontraseña(){
            this.actpassword = true;
            var caracteres = "BCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$%*+.?";
            var contrasena = "";
            var longitud = 9;
            this.password = '';
            for (var i = 0; i < longitud; i++) {
                const caracterAleatorio = caracteres.charAt(Math.floor(Math.random() * caracteres.length));
                contrasena += caracterAleatorio;
            }
            this.password = contrasena;
        }
    }
}
</script>